/*global page*/
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'tutorial';
  var pageManager = fc.pageManager;
  

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);
  currentPage.maxStep = 3;
  currentPage.currentStep = 0;
  currentPage.redirectTo='/create';
  currentPage.redirectedFrom = '/welcome';
  
  currentPage.middleContent = ['<p class="upper">How to snap a good selfie?</p><div class="middle" style="background-image:url(/assets/app/tutorial1.png)"></div><p class="lower"><span>Use the front camera & keep it a bit above eye level</span></p>','<p class="upper">How to snap a good selfie?</p><div class="middle" style="background-image:url(/assets/app/tutorial2.png)"></div><p class="lower"><span>Find a plain, single-color surface for background</span></p>','<p class="upper">How to snap a good selfie?</p><div class="middle" style="background-image:url(/assets/app/tutorial3.png)"></div><p class="lower"><span>Stand at least 1m away from the background</span></p>','<p class="upper">How to snap a good selfie?</p><div class="middle" style="background-image:url(/assets/app/tutorial4.png)"></div><p class="lower"><span>No group selfies, just one person per shot</span></p>'];

  currentPage.eventHandlers = fc.wizard.eventHandlers;

  currentPage.renderMiddle = fc.wizard.renderMiddle.bind(currentPage);

  currentPage.html = fc.wizard.getHtml(currentPage.redirectTo);

  currentPage.run = fc.wizard.run.bind(currentPage);
  pageManager.add(currentPage);

}(FakeCation));
